import { useEffect, useRef, useState } from "react";
import { useAIChat } from "../../context/AIChatContext";
import { LuBotMessageSquare } from "react-icons/lu";
import ReactMarkdown from "react-markdown";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";

const STOCK_SUMMARY_PROMPT = `
You are a Senior Equity Research Analyst for Indian NSE stocks.

Generate a professional **Stock Analysis Report** using the provided stock data.

STRICT STRUCTURE (do not change order or headings):

## 1. Executive Summary
- Company name and current price
- 1–2 lines summary of price action

## 2. Sentiment
- Overall Sentiment: **Bullish / Bearish / Neutral**
- RSI interpretation
- MACD interpretation
- PCR interpretation

## 3. Buy / Sell / Hold Rationale
- **Fundamentals:** P/E, profit margin, valuation, upside/downside
- **Technicals:** RSI level, MACD trend, momentum
- **Verdict:** BUY / SELL / HOLD with reason

## 4. Wealth Creation Analysis
- **Short-term (1W):** performance and meaning
- **Long-term (1Y–5Y):** wealth creator or destroyer

## 5. Derivatives Sentiment (PCR)
- PCR value
- What it signals

## 6. MACD Histogram & Trend
- Momentum strength
- Crossover / exhaustion status

Rules:
- Use Markdown ONLY
- Bold section headings
- Bullet points only (no paragraphs)
- No disclaimers
- No emojis
- No extra sections
`;
const GENERAL_PROMPT_WRAPPER = (userPrompt) => `
You are a precise assistant.

Answer the following query in a **clear, point-by-point Markdown format**.

Rules:
- Use bullet points
- Use headings if needed
- Be concise and factual
- No paragraphs
- No filler text
- No disclaimers

User Query:
${userPrompt}
`;
const MARKET_PROMPT = (symbol) => `
You are a market analyst.

Provide **Market News Report** for Indian NSE stock **${symbol}**.

STRICT STRUCTURE:

## Recent News
- Bullet headlines (last few days)

## Corporate Actions
- Results, orders, acquisitions, guidance

## Sector / Macro Impact
- Sector trends
- Policy or macro triggers

## Market Sentiment
- Bullish / Bearish / Neutral
- Short reasoning

Rules:
- Markdown only
- Bullet points only
- No disclaimers
- No conversational tone
`;
const ChatPanel2 = ({ stockContext }) => {
  const { chatOpen, closeChat } = useAIChat();
  const { sendPrompt, messages, loading, aiError } = useMarketIndicators();

  const [input, setInput] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  //existing code
  // const handleSend = () => {
  //   if (!input.trim()) return;
  //   sendPrompt(GENERAL_PROMPT_WRAPPER(input.trim())); // ✅ always fires
  //   setInput("");
  // };
  //New code
  const handleSend = () => {
    if (!input.trim()) return;

    sendPrompt(GENERAL_PROMPT_WRAPPER(input.trim()), {
      queryType: "GENERAL",
    });

    setInput("");
  };

  //   const handleStockSummary = () => {
  //     if (!stockContext) return;
  //     sendPrompt(STOCK_SUMMARY_PROMPT); // ✅ same pipeline
  //   };

  //existing code
  //   const handleStockSummary = () => {
  //     if (!stockContext) return;
  //     console.log("Market Summary Clicked!");

  //     const fullPrompt = `
  // ${STOCK_SUMMARY_PROMPT}

  // --- STOCK DATA ---
  // ${JSON.stringify(stockContext, null, 2)}
  // --- END STOCK DATA ---
  // `;

  //     sendPrompt(fullPrompt, {
  //       showUser: false,
  //     });
  //   };

  //new code
  const handleStockSummary = () => {
    if (!stockContext) return;

    const fullPrompt = `
${STOCK_SUMMARY_PROMPT}

--- STOCK DATA ---
${JSON.stringify(stockContext, null, 2)}
--- END STOCK DATA ---
`;

    sendPrompt(fullPrompt, {
      showUser: false,
      queryType: "STOCK_SUMMARY",
      symbol: stockContext.symbol,
      stockContext,
    });
  };
  //existing code
  // const handleMarketNews = () => {
  //   if (!stockContext) return;
  //   console.log("Market News Clicked!");
  //   sendPrompt(
  //     MARKET_PROMPT(stockContext.symbol),
  //     { showUser: false }, // 🔥 important
  //   );
  // };
  //new code using db
  const handleMarketNews = () => {
    if (!stockContext) return;

    sendPrompt(MARKET_PROMPT(stockContext.symbol), {
      showUser: false,
      queryType: "MARKET_NEWS",
      symbol: stockContext.symbol,
    });
  };

  return (
    <div className={`chat-panel ${chatOpen ? "open" : ""}`}>
      <div className="chat-header">
        <div style={{ display: "flex", gap: "10px" }}>
          <h3>Phro AI Assistant</h3>
          <LuBotMessageSquare style={{ alignSelf: "center" }} />
        </div>

        <button onClick={closeChat}>✕</button>
      </div>

      <div className="chat-messages">
        {messages?.map((msg, idx) => (
          <div
            key={idx}
            className={`chat-bubble ${msg.role} ${msg.error ? "error" : ""}`}
          >
            {/* {msg.text} */}
            <ReactMarkdown>{msg.text}</ReactMarkdown>
          </div>
        ))}

        {stockContext && (
          <div className="chat-top-tab">
            <button
              className="chat-chip"
              onClick={handleStockSummary}
              // disabled={loading}
            >
              Summary of this stock
            </button>
            <button
              className="chat-chip"
              onClick={handleMarketNews}
              // disabled={loading}
              //   disabled={inputDisabled}
            >
              Market News
            </button>
          </div>
        )}

        {loading && (
          <div className="chat-bubble ai typing">AI is typing...</div>
        )}

        <div ref={bottomRef} />
      </div>

      {aiError && <div className="chat-error">{aiError}</div>}

      <div className="chat-input">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          placeholder="Ask something..."
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
};
export default ChatPanel2;
